/* eslint-disable */
import React from 'react'
import { Row, Col, List } from 'antd'
import MenuContainer from '../../components/menu'
import {
  Wrapper, Image,
} from '../content/styled'
import { Button } from '../calculator/styled'
import { P } from './styled'
import { H2, H3, H4, P as CommonP } from '../../components/common/text'

const personalComputerData_1 = [
  'นั่งศีรษะตั้งตรงหรือก้มเล็กน้อย ระดับสายตาในแนวราบควรอยู่ระดับเดียวกับขอบบนของจอภาพ ไม่หมุนคอไปทางซ้ายหรือทางขวา',
  'ระยะมองจอภาพควรอยู่ระหว่าง 40-60 ซม. (หรือประมาณ 1 ช่วงแขน)',
  'นั่งหลังตั้งตรงหรือเอนไปด้านหลังเล็กน้อย (ถ้ามีพนักพิงหลัง)',
  'นั่งพิงพนักพิงหลัง (โดยเฉพาะอย่างยิ่ง บริเวณหลังส่วนล่าง)',
  'นั่งปฏิบัติงานโดยไม่บิดหรือเอียงตัวไปทางซ้ายหรือทางขวา',
  'แขนท่อนบนห้อยแนบขนานกับลำตัว ไม่นั่งยกไหล่หรือกางแขนออกทางด้านข้าง',
  'ไม่วางแขนบนที่พักแขนขณะปฏิบัติงานกับแป้นพิมพ์หรือเมาส์',
  'แขนท่อนล่างอยู่ในแนวราบ (ขนานกับพื้น) และทำมุมประมาณ 90 องศากับแขนท่อนบน (มุมที่ข้อศอก)',
  'มือและแขนท่อนล่างอยู่ในแนวเส้นตรงเดียวกัน ไม่งอข้อมือทั้งแนวดิ่งและแนวราบ',
  'ไม่วางฝ่ามือ (หรือข้อมือ) บนลิ้นชักวางแป้นพิมพ์ แป้นพิมพ์ หรือที่พักฝ่ามือ ถ้าไม่สามารถรักษาแนวเส้นตรงที่ข้อมือได้',
  'ขาท่อนบนอยู่ในแนวราบ (ขนานกับพื้น) และทำมุมประมาณ 90-110 องศากับลำตัว',
  'ขาท่อนล่างอยู่ในแนวดิ่ง (ตั้งฉากกับพื้น) และทำมุมประมาณ 90 องศากับขาท่อนบน (มุมที่หัวเข่า)',
  'วางเท้าทั้ง 2 ข้างบนพื้นหรือที่พักเท้า ไม่วางเท้าบนขาเก้าอี้หรือเบาะนั่ง',
]

const personalComputerData_2 = [
  'ใช้สถานีงานคอมพิวเตอร์ (โต๊ะคอมพิวเตอร์และเก้าอี้) และอุปกรณ์คอมพิวเตอร์ (แป้นพิมพ์ เมาส์ และจอภาพ) ที่ไม่ได้ออกแบบอย่างเหมาะสมตามหลักการยศาสตร์',
  'ใช้สถานีงานคอมพิวเตอร์ที่ไม่สามารถปรับระดับให้เหมาะสมกับสัดส่วนของร่างกายพนักงาน',
  'ใช้โต๊ะทำงาน (โต๊ะเขียนหนังสือ) เป็นโต๊ะวางอุปกรณ์คอมพิวเตอร์',
  'ไม่ปรับระดับของอุปกรณ์คอมพิวเตอร์ให้เหมาะสมกับสัดส่วนของร่างกายพนักงาน',
  'จัดวางอุปกรณ์คอมพิวเตอร์ตามตำแหน่งที่ไม่เหมาะสม',
  'ไม่รู้ว่าท่านั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์ตั้งโต๊ะที่เหมาะสมเป็นอย่างไร',
  'มีนิสัยหรือพฤติกรรมในการปฏิบัติงานที่ไม่เหมาะสมตามหลักการยศาสตร',
]

const notebookData_1 = [
  'นั่งศีรษะตั้งตรงหรือก้มเล็กน้อย (ไม่เกิน 10องศา) ระดับสายตาในแนวราบควรอยู่สูงกว่าระดับขอบบนของจอภาพเล็กน้อย ไม่หมุนคอไปทางซ้ายหรือทางขวา',
  'ระยะมองจอภาพควรอยู่ระหว่าง 40-60 ซม. (หรือประมาณ 1 ช่วงแขน)',
  'นั่งหลังตั้งตรงหรือเอนไปด้านหลังเล็กน้อย (ถ้ามีพนักพิงหลัง)',
  'นั่งพิงพนักพิงหลัง (โดยเฉพาะอย่างยิ่ง บริเวณหลังส่วนล่าง)',
  'นั่งปฏิบัติงานโดยไม่บิดหรือเอียงตัวไปทางซ้ายหรือทางขวา',
  'แขนท่อนบนยื่นไปข้างหน้าเล็กน้อย (ไม่เกิน 20 องศา) ไม่นั่งยกไหล่หรือกางแขนออกทางด้านข้าง',
  'ไม่วางแขนบนโต๊ะหรือที่พักแขน ขณะปฏิบัติงานเครื่องคอมพิวเตอร์พกพา',
  'แขนท่อนล่างทำมุมประมาณ 90 องศากับแขนท่อนบน (มุมที่ข้อศอก)',
  'มือและแขนท่อนล่างอยู่ในแนวเส้นตรงเดียวกัน ไม่งอข้อมือทั้งแนวดิ่งและแนวราบ',
  'ขาท่อนบนอยู่ในแนวราบ (ขนานกับพื้น) และทำมุมประมาณ 90-110 องศากับลำตัว',
  'ขาท่อนล่างอยู่ในแนวดิ่ง (ตั้งฉากกับพื้น) และทำมุมประมาณ 90 องศากับขาท่อนบน (มุมที่หัวเข่า)',
  'วางเท้าทั้ง 2 ข้างบนพื้นหรือที่พักเท้า ไม่วางเท้าบนขาเก้าอี้หรือเบาะนั่ง',
]

const notebookData_2 = [
  'ใช้สถานีงานคอมพิวเตอร์ (โต๊ะคอมพิวเตอร์และเก้าอี้) ที่ไม่ได้ออกแบบอย่างเหมาะสมตามหลักการยศาสตร์',
  'ใช้สถานีงานคอมพิวเตอร์ที่ไม่สามารถปรับระดับให้เหมาะสมกับสัดส่วนของร่างกายพนักงานได้',
  'จัดวางเครื่องคอมพิวเตอร์พกบนโต๊ะอย่างไม่เหมาะสม (ไม่ใช้ฐานวางเครื่องคอมพิวเตอร์พกพา)',
  'ไม่สามารถปรับระดับแป้นพิมพ์และจอภาพได้อย่างเป็นอิสระ เนื่องจากส่วนแป้นพิมพ์และส่วนจอภาพยึดติดกันด้วยบานพับ',
  'ไม่รู้ว่าท่านั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์พกพาที่เหมาะสมตามหลักการยศาสตร์เป็นอย่างไร',
  'มีนิสัยหรือพฤติกรรมในการปฏิบัติงานที่ไม่เหมาะสมตามหลักการยศาสตร์',
]

export default class Continer extends React.PureComponent {
  render() {
    return (
      <div>
        <MenuContainer solid={true} />
        <Row justify='center' type='flex' style={{ padding: '55px 0' }}>
          <Col xs={20} lg={18} xl={16}>
            <Row justify='center' type='flex'>
              <H2>ท่านั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์</H2>
            </Row>
            <PersonalComputer />
            <Notebook />
            <Row justify='center' type='flex'>
              <H4>มาตรฐานการปฏิบัติงานคอมพิวเตอร์ตามหลักการยศาสตร์ (มปอ. 2301)</H4>
            </Row>
            <Row justify='center' type='flex'>
              <a href='https://drive.google.com/open?id=11zAecy07-XPhmPWaK6IUzr49Yju09efc' target='_blank'>
                <Button type="primary">ดาวน์โหลด</Button>
              </a>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

const PersonalComputer = () => (
  <Wrapper>
    <Row justify='center' type='flex' style={{ marginBottom: 32 }}>
      <H3>ท่านั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์ตั้งโต๊ะ</H3>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P>เครื่องคอมพิวเตอร์ตั้งโต๊ะเป็นอุปกรณ์ในการปฏิบัติงานที่สำคัญสำหรับพนักงานสำนักงานส่วนใหญ่ โดยเฉพาะอย่างยิ่งพนักงานที่ต้องปฏิบัติงานที่สถานีงานส่วนบุคคลและไม่โยกย้ายตามวันหรือเวลาต่าง ๆ รวมทั้งพนักงานที่ไม่จำเป็นต้องไปปฏิบัติงานนอกสถานที่หรือต้องนำงานกลับไปทำนอกเวลาทำงานที่บ้าน เครื่องคอมพิวเตอร์ตั้งโต๊ะประกอบด้วยแป้นพิมพ์ เมาส์ จอภาพ และหน่วยประมวลผลกลาง แต่อุปกรณ์ที่พนักงานต้องปฏิบัติงานด้วยเป็นอุปกรณ์หลักและมีปฏิสัมพันธ์อย่างต่อเนื่อง คือ แป้นพิมพ์ เมาส์ และจอภาพ โดยที่การปฏิสัมพันธ์ระหว่างพนักงานและแป้นพิมพ์หรือเมาส์ เป็นทั้งเชิงกายภาพและเชิงการรับรู้โดยการมองเห็น ส่วนการปฏิสัมพันธ์ระหว่างพนักงานและจอภาพ เป็นการปฏิสัมพันธ์เชิงการรับรู้โดยการมองเห็น</P>
      </Col>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P style={{ padding: 10 }}>ท่านั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์ตั้งโต๊ะตามหลักการยศาสตร์ สามารถสรุปได้ดังนี้</P>
      </Col>
      <Col offset={2} span={22}>
        <ol>
          {
            personalComputerData_1.map(v => (
              <li style={{ lineHeight: 2 }}>{v}</li>
            ))
          }
        </ol>
      </Col>
    </Row>
    <Row gutter={32} style={{ marginBottom: 50 }} type='flex' justify='center'>
      <Col xs={20} lg={16}>
        <Image src={require('../../images/work-posture/1.jpg')}/>
      </Col>
    </Row>
    <Row>
      <Col span={24}>
        <P style={{ padding: 10 }}>ในสำนักงานทั่วไป พนักงานเป็นจำนวนมากนั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์ตั้งโต๊ะด้วยท่าทางที่ไม่เหมาะสม สาเหตุที่ทำให้พนักงานนั่งปฏิบัติงานอย่างไม่ถูกต้อง คือ</P>
      </Col>
      <Col offset={2} span={22}>
        <ol>
          {
            personalComputerData_2.map(v => (
              <li style={{ lineHeight: 2 }}>{v}</li>
            ))
          }
        </ol>
      </Col>
    </Row>
  </Wrapper>
)

const Notebook = () => (
  <Wrapper>
    <Row justify='center' type='flex' style={{ marginBottom: 32 }}>
      <H3>ท่านั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์พกพา</H3>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P>ในปัจจุบัน เนื่องจากเครื่องคอมพิวเตอร์พกพามีราคาถูกลงและมีสมรรถภาพเพิ่มขึ้นใกล้เคียงกับเครื่องคอมพิวเตอร์ตั้งโต๊ะ องค์กรหลายแห่งได้อนุญาตให้พนักงานสำนักงานเลือกว่าต้องการใช้เครื่องคอมพิวเตอร์ตั้งโต๊ะหรือเครื่องคอมพิวเตอร์พกพาในการปฏิบัติงานในสำนักงาน ซึ่งพนักงานเป็นจำนวนมากเลือกใช้เครื่องคอมพิวเตอร์พกพา โดยเฉพาะอย่างยิ่งพนักงานที่ต้องปฏิบัติงานตามสถานีงานหรือสถานที่หลายแห่ง โดยอาจจะโยกย้ายตามวันหรือเวลาต่าง ๆ รวมทั้งพนักงานที่จำเป็นต้องไปปฏิบัติงานนอกสถานที่หรือต้องนำงานกลับไปทำนอกเวลาทำงานที่บ้านด้วย เครื่องคอมพิวเตอร์พกพาประกอบด้วยส่วนแป้นพิมพ์และส่วนจอภาพซึ่งยึดติดกันด้วยบานพับ และมีหน่วยประมวลผลกลางอยู่ในส่วนแป้นพิมพ์ และแผ่นสัมผัสบนส่วนแป้นพิมพ์ซึ่งปฏิบัติงานคล้ายคลึงกับเมาส์ เครื่องคอมพิวเตอร์พกพาบางเครื่องอาจจะมีจอภาพเป็นประเภทจอสัมผัส ซึ่งสามารถรับข้อมูลได้โดยตรงโดยไม่ต้องผ่านแป้นพิมพ์</P>
      </Col>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P style={{ padding: 10 }}>ท่านั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์พกพาตามหลักการยศาสตร์ สามารถสรุปได้ดังนี้</P>
      </Col>
      <Col offset={2} span={22}>
        <ol>
          {
            notebookData_1.map(v => (
              <li style={{ lineHeight: 2 }}>{v}</li>
            ))
          }
        </ol>
      </Col>
    </Row>
    <Row gutter={32} style={{ marginBottom: 50 }} type='flex' justify='center'>
      <Col xs={20} lg={16}>
        <Image src={require('../../images/work-posture/2.jpg')}/>
      </Col>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P style={{ padding: 10 }}>ในสำนักงานทั่วไป พนักงานเป็นจำนวนมากนั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์พกพาด้วยท่าทางที่ไม่เหมาะสม สาเหตุที่ทำให้พนักงานนั่งปฏิบัติงานอย่างไม่ถูกต้อง คือ</P>
      </Col>
      <Col offset={2} span={22}>
        <ol>
          {
            notebookData_2.map(v => (
              <li style={{ lineHeight: 2 }}>{v}</li>
            ))
          }
        </ol>
      </Col>
    </Row>
  </Wrapper>
)